











































import { Component, Mixins } from "vue-property-decorator";
// Components
import TicketsProvider from "@/components/app/global/tickets/ticketsProvider";
import { mapState } from "vuex";
import { IState } from "@/store";
import { ListDisplayMode } from "@/data/constants";

@Component({
  components: {
    "inbox-filter-controls": () =>
      import("@/components/app/global/tickets/inboxFilterControls.vue"),
    "inbox-sort-controls": () =>
      import("@/components/app/global/tickets/inboxSortControls.vue"),
    "inbox-pagination-controls": () =>
      import("@/components/app/global/tickets/inboxPaginationControls.vue"),
    "inbox-list": () => import("@/components/app/global/tickets/inboxList.vue"),
    "inbox-table": () =>
      import("@/components/app/global/tickets/inboxTable.vue"),
    "tickets-stats": () =>
      import("@/components/app/global/tickets/ticketsStats.vue")
  },
  computed: {
    ...mapState({
      displayMode: (state: IState) => state.ui.support.displayMode
    })
  }
})
export default class AdminInbox extends Mixins(TicketsProvider) {
  // Data

  public displayMode!: ListDisplayMode;

  // Life-cycle methods

  public created() {
    this.initTicketsProvider();
  }

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
  // Computed

  public get showTicketSlot() {
    return this.$_.has(this.$route, "params.ticketId");
  }

  public get showStatsSlot() {
    return !this.showTicketSlot && this.$store.getters["ui/isWidescreenPlus"];
  }

  public get display() {
    const inbox = {
      slot: ListDisplayMode.INBOX,
      layout: "ticket-inbox-layout",
      components: [
        "inbox-sort-controls",
        "inbox-list",
        "inbox-pagination-controls"
      ]
    };

    const table = {
      slot: ListDisplayMode.TABLE,
      layout: "ticket-table-layout",
      components: [
        "inbox-sort-controls",
        "inbox-table",
        "inbox-pagination-controls"
      ]
    };

    return this.displayMode === ListDisplayMode.INBOX ? inbox : table;
  }
}
